import api from './api'

/**
 * 获取用户列表
 * @param {Object} params 查询参数
 * @param {string} params.username 用户名
 * @param {string} params.email 邮箱
 * @param {number} params.page 页码，从1开始
 * @param {number} params.size 每页条数，最大100
 * @returns {Promise} 包含items和total的对象
 */
export async function getUsers(params) {
  const res = await api.get('/api/v1/users', { params })
  return res.data
}

/**
 * 获取用户详情
 * @param {string|number} id 用户ID
 * @returns {Promise}
 */
export async function getUser(id) {
  const res = await api.get(`/api/v1/users/${id}`)
  return res.data
}

/**
 * 创建用户
 * @param {Object} userData 用户数据
 * @param {string} userData.username 用户名
 * @param {string} userData.email 邮箱
 * @param {string} userData.password 密码
 * @param {string} userData.full_name 姓名（可选）
 * @param {boolean} userData.is_active 激活状态（可选）
 * @param {boolean} userData.is_superuser 超级用户（可选）
 * @returns {Promise}
 */
export async function createUser(userData) {
  const res = await api.post('/api/v1/users', userData)
  return res.data
}

/**
 * 更新用户
 * @param {string|number} id 用户ID
 * @param {Object} userData 用户数据
 * @param {string} userData.username 用户名（可选）
 * @param {string} userData.email 邮箱（可选）
 * @param {string} userData.password 密码（可选）
 * @param {string} userData.full_name 姓名（可选）
 * @param {boolean} userData.is_active 激活状态（可选）
 * @param {boolean} userData.is_superuser 超级用户（可选）
 * @returns {Promise}
 */
export async function updateUser(id, userData) {
  const res = await api.put(`/api/v1/users/${id}`, userData)
  return res.data
}
